<template lang="pug">
  #app.app(:class="{ 'app--iframe': onIframe, 'themeBB': $partnerBB }")
    router-view
</template>

<script>
export default {
  data () {
    return {
      onIframe: window.self !== window.top
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/index";

html {
  scroll-behavior: smooth;
}

button {
  touch-action: manipulation;
}

.app--iframe {
  position: fixed;
  top: 0;
  right:0;
  bottom:0;
  left: 0;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
</style>
